import PropTypes from 'prop-types';

const ShowMoreButton = ({ count, onClickHandler }) => {
  return (
    <div
      className="lp-filter-show-more text-primary hover:text-blue-800 cursor-pointer py-1.5"
      onClick={onClickHandler}
    >
      Show {count} More <i className="fa-regular fa-angle-down mt-px ml-px" />
    </div>
  );
};

ShowMoreButton.propTypes = {
  count: PropTypes.number,
  onClickHandler: PropTypes.func
};

export default ShowMoreButton;
